import React, { useState } from "react";
import { useUser } from "../../../context/user-context";
import { FaRegTimesCircle } from "react-icons/fa";
import { logo, smallLogo } from "../../../assets/images";
import { CgChevronLeftR } from "react-icons/cg";
import SelectCountry from "./components/SelectCountry";
import SelectDocument from "./components/SelectDocument";
import UploadGovId from "./components/UploadGovId";
import PoF from "./components/PoF";
import SelectUtility from "./components/SelectUtility";
import UploadHouse from "./components/UploadHouse";
import LivenessCheck from "./components/LivenessCheck";

const Kyc3Screens = ({
  setOpenKyc3Start,
  setOpenKyc3Screens,
  setKycSuccess,
}: any) => {
  const { theme } = useUser();
  const [screen, setScreen] = useState<number>(1);
  const [country, setCountry] = useState<string>("");
  const [document, setDocument] = useState<string>("");
  const [govIdFile, setGovIdFile] = useState<File | null>(null);
  const [govSignedUrl, setGovSignedUrl] = useState<string>("");
  const [govObjectUrl, setGovObjectUrl] = useState<string>("");

  //HouseAddress
  const [houseNo, setHouseNo] = useState<string>("");
  const [houseAddress, setHouseAddress] = useState<string>("");
  const [houseLandmark, setHouseLandmark] = useState<string>("");
  const [utility, setUtility] = useState<string>("");
  const [meterNo, setMeterNo] = useState<string>("");
  const [houseIdFile, setHouseIdFile] = useState<File | null>(null);
  const [houseSignedUrl, setHouseSignedUrl] = useState<string>("");
  const [houseObjectUrl, setHouseObjectUrl] = useState<string>("");
  const [govNumber, setGovNumber] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");

  //Liveness check

  const [livenessIdFile, setLivenessIdFile] = useState<File | null>(null);
  const [livenessSignedUrl, setLivenessSignedUrl] = useState<string>("");
  const [livenessObjectUrl, setLivenessObjectUrl] = useState<string>("");
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        {" "}
        <div className="w-full flex px-3 mt-4 gap-12 justify-between items-center">
          <CgChevronLeftR
            onClick={() => {
              if (screen === 1) {
                setOpenKyc3Screens(false);
                setOpenKyc3Start(true);
              } else {
                setScreen((prev) => prev - 1);
              }
            }}
            className="text-gray-900 dark:text-gray-100 text-[22px] cursor-pointer"
          />
          <div className="">
            {theme === "dark" ? (
              <img src={logo} className="mx-auto " alt="" />
            ) : (
              <img src={smallLogo} className="mx-auto " alt="" />
            )}
          </div>{" "}
          <FaRegTimesCircle
            onClick={() => {
              setOpenKyc3Start(false);
              setOpenKyc3Screens(false);
            }}
            className="text-gray-800 dark:text-gray-100 text-[22px] cursor-pointer"
          />
        </div>
        <div className="mt-10 w-full">
          {screen === 1 ? (
            <SelectCountry
              setScreen={setScreen}
              setCountry={setCountry}
              country={country}
            />
          ) : screen === 2 ? (
            <SelectDocument
              setScreen={setScreen}
              country={country}
              document={document}
              setDocument={setDocument}
              setGovNumber={setGovNumber}
              govNumber={govNumber}
            />
          ) : screen === 3 ? (
            <UploadGovId
              setScreen={setScreen}
              document={document}
              govIdFile={govIdFile}
              setGovIdFile={setGovIdFile}
              govSignedUrl={govSignedUrl}
              setGovSignedUrl={setGovSignedUrl}
              govObjectUrl={govObjectUrl}
              setGovObjectUrl={setGovObjectUrl}
            />
          ) : screen === 4 ? (
            <PoF
              setScreen={setScreen}
              country={country}
              houseNo={houseNo}
              setHouseNo={setHouseNo}
              houseAddress={houseAddress}
              setHouseAddress={setHouseAddress}
              houseLandmark={houseLandmark}
              setHouseLandmark={setHouseLandmark}
              city={city}
              setCity={setCity}
              state={state}
              setState={setState}
              postalCode={postalCode}
              setPostalCode={setPostalCode}
            />
          ) : screen === 5 ? (
            <SelectUtility
              setScreen={setScreen}
              country={country}
              utility={utility}
              setUtility={setUtility}
            />
          ) : screen === 6 ? (
            <UploadHouse
              setScreen={setScreen}
              utility={utility}
              houseIdFile={houseIdFile}
              setHouseIdFile={setHouseIdFile}
              houseSignedUrl={houseSignedUrl}
              setHouseSignedUrl={setHouseSignedUrl}
              houseObjectUrl={houseObjectUrl}
              setHouseObjectUrl={setHouseObjectUrl}
              setMeterNo={setMeterNo}
              meterNo={meterNo}
            />
          ) : screen === 7 ? (
            <LivenessCheck
              livenessIdFile={livenessIdFile}
              setLivenessIdFile={setLivenessIdFile}
              livenessSignedUrl={livenessSignedUrl}
              setLivenessSignedUrl={setLivenessSignedUrl}
              livenessObjectUrl={livenessObjectUrl}
              setLivenessObjectUrl={setLivenessObjectUrl}
              setKycSuccess={setKycSuccess}
              setOpenKyc3Screens={setOpenKyc3Screens}
              utility={utility}
              country={country}
              houseObjectUrl={houseObjectUrl}
              houseNo={houseNo}
              houseAddress={houseAddress}
              houseLandmark={houseLandmark}
              document={document}
              govObjectUrl={govObjectUrl}
              govNumber={govNumber}
              setGovNumber={setGovNumber}
              city={city}
              state={state}
              postalCode={postalCode}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Kyc3Screens;
